import { render, staticRenderFns } from "./BlackHole.vue?vue&type=template&id=627467d6&"
import script from "./BlackHole.vue?vue&type=script&lang=js&"
export * from "./BlackHole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports